export class ValidationUtils {
    static isValidEmail(email: string): boolean {
        const expression = /^[A-Za-z0-9._%+-]+@(?:[A-Za-z0-9-]+\.)+[A-Za-z]{2,}$/i;
        return expression.test(email);
    }

    static isValidPostalCode(contractorPostalCode: string) {
        if (isNaN(Number(contractorPostalCode))) {
            return false;
        }
        const expression = /^[0-9]{4}$/i;
        return expression.test(contractorPostalCode);
    }

    static notEmpty<TValue>(value: TValue): value is NonNullable<TValue> {
        return value !== null && value !== undefined;
    }

}